import React, { useState } from "react";
import "./loader.css";
import { superUserLogin } from "../../actions/AuthAction";
import constant from "../../constant";
import { useHistory } from "react-router-dom";

function Login() {
  const router = useHistory();

  const [data, setData] = useState({
    emp: { name: "emp", value: "", required: true, error: "" },
    password: { name: "password", value: "", required: true, error: "" },
    showLoader: false,
    bg: "white",
  });

  const { emp, password, showLoader, bg } = data;

  const Login = (e) => {
    const { emp, password, showLoader } = data;
    e.preventDefault();

    let model = {
      employeeNumber: Number(emp.value),
      password: password.value,
    };

    setData({ ...data, showLoader: true, bg: "black" });

    superUserLogin(model)
      .then((result) => {
        if (result.status == constant.static.apiStatus.success) {
          setTimeout(() => {
            window.localStorage.setItem(
              constant.cookie.superUserToken,
              result.result
            );
            setData({ ...data, showLoader: false, bg: "white" });
            router.push(constant.component.superUserDashboard.url);
          }, 1000);
        } else {
          setData({ ...data, showLoader: false, bg: "white" });
          alert(result.error);
        }
      })
      .catch((err) => {
        alert(err.message);
        setData({ ...data, showLoader: false, bg: "white" });
      });
  };

  function onChangeHandler(e) {
    const { name, value } = e.target;
    setData({ ...data, [name]: { ...data[name], value: value } });
  }

  return (
    <div
      className="d-flex justify-center align-items-center "
      style={{ height: "100vh", background: bg }}
    >
      {showLoader && (
        <div>
          <span className="loader"></span>
        </div>
      )}

      {!showLoader && (
        <form onSubmit={(e) => Login(e)}>
          <div className="form-group">
            <label> Employee Number </label>
            <input
              type="text"
              name={emp.name}
              value={emp.value}
              onChange={onChangeHandler}
              className="form-control"
              id="exampleInputEmail1"
              aria-describedby="emailHelp"
              placeholder="Enter email"
            />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input
              name={password.name}
              value={password.value}
              onChange={onChangeHandler}
              type="password"
              className="form-control"
              id="exampleInputPassword1"
              placeholder="Password"
            />
          </div>
          <div className="form-check"></div>

          <button type="submit" className="btn btn-block btn-primary">
            Login
          </button>
        </form>
      )}
    </div>
  );
}

export default Login;
